import { Heading } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonFormGrid } from 'components/common/form/grid';
import { CommonTextInput } from 'components/common/form/text';
import { SectionBox } from 'components/sections/feature-demo/section-box';
import { RegexFilter } from 'interfaces/forms/text';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useState } from 'react';

export const TextInputsDemo = () => {
  const [alpha, setAlpha] = useState('');
  const [alphaNum, setAlphaNum] = useState('');
  const [whitespace, setWhitespace] = useState('');

  return (
    <ErrorBoundary componentName="TextInputsDemo">
      <SectionBox>
        <Heading size={RADIX.HEADING.SIZE.MD}>Regex Text Inputs</Heading>

        <CommonFormGrid columns={3}>
          <CommonTextInput
            id="demo-alpha"
            label="Alpha"
            value={alpha}
            regex={RegexFilter.Alpha}
            onChange={(v) => setAlpha(v ?? '')}
          />
          <CommonTextInput
            id="demo-alpha-num"
            label="AlphaNumeric"
            value={alphaNum}
            regex={RegexFilter.AlphaNumeric}
            onChange={(v) => setAlphaNum(v ?? '')}
          />
          <CommonTextInput
            id="demo-whitespace"
            label="Whitespace"
            value={whitespace}
            regex={RegexFilter.Whitespace}
            onChange={(v) => setWhitespace(v ?? '')}
          />
        </CommonFormGrid>
      </SectionBox>
    </ErrorBoundary>
  );
};
